var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInoming1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 725,
    viewBox: "0 0 725 725",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.742 281.334C150.155 419.905 185.167 508.317 189.3 517.942C192.468 525.333 198.321 531.307 205.668 534.55C209.439 536.24 299.888 575.34 442.712 528.335C459.517 522.814 468.643 504.727 463.107 487.938C457.586 471.163 439.499 462.007 422.71 467.543C363.622 486.987 315.878 489.144 282.872 486.399L527.942 241.329C540.448 228.824 540.448 208.58 527.942 196.074C515.437 183.569 495.193 183.569 482.687 196.074L237.678 441.084C234.947 408.063 237.105 360.349 256.519 301.322C260.411 289.465 257.002 276.944 248.735 268.678C245.296 265.239 241.042 262.553 236.109 260.939C219.319 255.403 201.248 264.545 195.712 281.334L195.742 281.334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(362.039 724.077) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInoming1);
export default __webpack_public_path__ + "static/media/Inoming 1.4f85fe7213b67da4a6d2a68ab1567594.svg";
export { ForwardRef as ReactComponent };